export default __webpack_public_path__ + "static/media/ouman.d9528468.png";